import React, { useState } from 'react';

const base64Logo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxZDQ2MjI4YS03NWY2LTRkZTQtOGJjYy1hODc1NjRkMjYxYTUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDQ3MUVFMDFFMjVDMTFFNjlFQjhBRjdGODU5MDJBMDUiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDQ3MUVFMDBFMjVDMTFFNjlFQjhBRjdGODU5MDJBMDUiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxZDQ2MjI4YS03NWY2LTRkZTQtOGJjYy1hODc1NjRkMjYxYTUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MWQ0NjIyOGEtNzVmNi00ZGU0LThiY2MtYTg3NTY0ZDI2MWE1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+8JtvywAAAKhQTFRFzOPxSJvLA3W4Mo7FBna5w97u8vj7EHy8a67VhbzdsdTpVaLPh73d9/v9C3m6QZfJbq/WXKbR3u32JIfB3ez1KorDir/eBHW4+/3+rtPoZarUG4K/LIvDDnu7ocvkf7nbdrTY9fr8E328WKPQO5PITJ3MPpXJstXptdbq+Pv9cbHXaq3VU6HOkMLgnMnjDHq62uv1/P3+6/T53Oz1cLDX/f7+AHO3////ptOZ5QAAADh0Uk5T/////////////////////////////////////////////////////////////////////////wA7XBHKAAAAmUlEQVR42sSRRxLCMAxFRSq9907ovebr/jdDMWYGxmZL3sIqbyFbJv4B/VlkVlerKALTD3G46Mx3AOR1UZ/TsDxW6W0gfYRNVfTCFu2AWpAMgMItMW+zQJU2UjWI29D0+e5KWNPMk+A9Om+B/UgOJyCuwMJCrpuziYkIsglfRByZ/XM3eXnBFEu1kpMpjq9dxQYp/OAXTwEGAB7Rc1xVnPemAAAAAElFTkSuQmCC';

const siteBadgeStyle = {
  backgroundColor: '#0073b7',
  borderRadius: '3px 0 0 3px',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  position: 'fixed',
  display: 'block !important',
  zIndex: 10000000000,
  padding: 0,
  width: '44px',
  height: '40px',
  textIndent: '-10000px',
  opacity: 1.0,
};

const spanStyle = {
  position: 'absolute',
  left: '-10000px',
  top: 'auto',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
};

const logoStyle = {
  display: 'block',
  width: '40px',
  height: '40px',
  background: 'white',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '8px 8px',
  backgroundImage: `url(${base64Logo})`,
};

const SiteBadge = (props) => {
  const {
    location = 'hidden',
    baseUrl,
    hint,
    onClick,
  } = props;

  const [badgeOpened, setBadgeOpened] = useState(false);

  const handleMouseOver = () => {
    if (location !== 'hidden') {
      setBadgeOpened(true);
    }
  };

  const handleMouseOut = () => {
    setBadgeOpened(false);
  };

  const handleClick = () => {
    if (badgeOpened && onClick) {
      onClick();
    }
  };

  const hintView = hint && (
    <img
      className="sumome-badge-hint"
      src={`${baseUrl}images/control-click-here-v2.png`}
      style="position:absolute;z-index:1;top:-21px;left:-319px;width:319px;max-width:none;height:86px;"
    />
  );


  const badgeLocationStyle = {};
  const logoLocationStyle = {};

  if (location === 'hidden') {
    badgeLocationStyle.display = 'none';
  } else {
    if (location.startsWith('t')) {
      badgeLocationStyle.top = '40px';
    } else {
      badgeLocationStyle.bottom = '40px';
    }

    if (location.endsWith('l')) {
      badgeLocationStyle.left = '-40px';
      badgeLocationStyle.borderRadius = '0 3px 3px 0';
    } else {
      badgeLocationStyle.right = '-40px';
      badgeLocationStyle.borderRadius = '3px 0 0 3px';
      logoLocationStyle.marginLeft = '4px';
    }

    // apply hover state
    if (badgeOpened) {
      const direction = location.endsWith('l') ? 'left' : 'right';
      badgeLocationStyle[direction] = '0';
    }
  }

  return (
    <button
      role='button'
      title='BDOW!'
      style={{ ...siteBadgeStyle, ...badgeLocationStyle }}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      <span style={spanStyle}>BDOW!</span>
      <span style={{ ...logoStyle, ...logoLocationStyle }} />
      {hintView}
    </button>
  );
};

export default SiteBadge;
